'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOfficeHoursMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isOfficeHoursMessage = exports.isOfficeHoursMessage = (0, _isType.isType)(_messageTypes.OFFICE_HOURS);